"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PageController = /*#__PURE__*/function () {
  function PageController() {
    _classCallCheck(this, PageController);
    this.body = document.getElementsByTagName("body")[0];
    this.footer = document.getElementById("global-footer");
    this.content = document.getElementById("content");
    this.template = $('body').data('template');
    this.windowST = 0;
    Date.prototype.addDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };

    /*setTimeout(function(){
        $(".blue.spacing.detail").css("z-index", "5000");
        $(".swiper-container").addClass("big");
        $(window).resize();
     }, 5000);*/

    this.scrollTop = $(document).scrollTop();
    this.footerHeight = this.getFooterHeight();

    // detect platform
    this.platform = new Platform();

    // header
    this.header = new Header(this);
    this.mobileMenu = new MobileMenu();
    this.initHighlightTapLinks();

    // init all default sliders
    this.initSliders();
    this.initTestimonialSliderMultiple();
    this.initAdvertisementWindow();

    // init parallax
    // except on page support with browser Safari
    if (!(this.template === 'support' && this.platform.isSafari())) {
      this.initCoverParallax();
      this.initStickyParallax();
      if (this.platform.isDesktop()) {
        this.initTileParallax();
      }
    }

    // init video (youtube) videos
    this.initVideoTestimonials();

    // animated number counters
    this.initNumberCounters();

    // highlight tiles
    this.initTileHighlightOnScroll();
    this.initLazyLoadImage();
    this.showPrivacyInformation();
    this.setTelPrefixToDefault();
    var clientIpInfo = this.getClientIPInfo();
    if (clientIpInfo !== null) {
      this.setTelPrefixContactForm(clientIpInfo);
    }

    // SECURE FORM TO ZENDESK TICKET
    var c1 = $("#frm-c1").val();
    var c2 = $("#frm-c2").val();
    var spamSecureField = $(".frm-spamSecureSum");
    setTimeout(function () {
      spamSecureField.val(parseInt(c1) + parseInt(c2));
    }, 10000);
    spamSecureField.hide();

    // SECURE FORM TO FOOTER QUESTION
    var c1_ft = $("#frm-ft-c1").val();
    var c2_ft = $("#frm-ft-c2").val();
    var spamSecureField_ft = $(".frm-ft-spamSecureSum");
    setTimeout(function () {
      spamSecureField_ft.val(parseInt(c1_ft) + parseInt(c2_ft));
    }, 10000);
    spamSecureField_ft.hide();
    spamSecureField.val(parseInt(c1) + parseInt(c2));
    spamSecureField.hide();
    this.clickToAnchorScroll();
    this.hoverToPartnerLogo();
    this._watchedEventLinksShop = ".click-shop-link";
    this._watchedEventShortlinks = ".click-shortlink";
    this._watchedEventGenericLink = ".click-general-external-link";
    this.watchClickToEventLinkShop();
    this.watchClickToEventShorlink();
    this.watchClickToEventGenericLink();
    this.initKeystrokeCounterOnForms();
  }
  return _createClass(PageController, [{
    key: "initKeystrokeCounterOnForms",
    value: function initKeystrokeCounterOnForms() {
      var keystrokeCounter = '.contactForm-KeystrokeCount';
      $("form").keyup(function () {
        var counter = $(keystrokeCounter, this);
        if (counter.length !== 0) {
          var currentCountString = counter.val();
          var currentCount = parseInt(currentCountString);
          counter.val(currentCount += 1);
        }
      });
    }
  }, {
    key: "watchClickToEventGenericLink",
    value: function watchClickToEventGenericLink() {
      var _this = this;
      $("html").on("click", _this._watchedEventGenericLink, function () {
        var link = $(this);
        gtag('event', 'click-external-link', {
          'event_category': "generic",
          'event_label': link.attr("data-link")
        });

        // REDIRECT TO LINK
        window.open(link.attr("data-link"), '_blank');
      });
    }
  }, {
    key: "watchClickToEventShorlink",
    value: function watchClickToEventShorlink() {
      var _this = this;
      $("html").on("click", _this._watchedEventShortlinks, function () {
        var link = $(this);
        gtag('event', 'click-external-link', {
          'event_category': "shorlink",
          'event_label': link.attr("data-link")
        });

        // REDIRECT TO LINK
        window.open(link.attr("data-link"), '_blank');
      });
    }
  }, {
    key: "watchClickToEventLinkShop",
    value: function watchClickToEventLinkShop() {
      var _this = this;
      $("html").on("click", _this._watchedEventLinksShop, function () {
        var link = $(this);
        gtag('event', 'click-external-link', {
          'event_category': "eshop",
          'event_label': link.attr("data-link")
        });

        // REDIRECT TO LINK
        window.open(link.attr("data-link"), '_blank');
      });
    }
  }, {
    key: "hoverToPartnerLogo",
    value: function hoverToPartnerLogo() {
      var _this = this;
      var defaultLogo = $(".defaultLogo");
      var partnerLogo = $(".partnerLogo", ".dropdown-menu-logo");
      var dropDownLogo = $(".dropdown-menu-logo");
      partnerLogo.mouseenter(function () {
        dropDownLogo.addClass("deactive");
        partnerLogo.addClass("active");
        defaultLogo.removeClass("active");
      }).mouseleave(function () {
        dropDownLogo.removeClass("deactive");
        partnerLogo.removeClass("active");
        defaultLogo.addClass("active");
      });
    }
  }, {
    key: "setTelPrefixContactForm",
    value: function setTelPrefixContactForm(clientIpInfo) {
      if ($("select[name='prefix_number']").length > 0) {
        $("select[name='prefix_number']").val(clientIpInfo.country).trigger('change');
      }
    }
  }, {
    key: "initAdvertisementWindow",
    value: function initAdvertisementWindow() {
      var _this2 = this;
      var advertisement = $("#advertisement");
      if (advertisement.length >= 1) {
        var name = advertisement.attr("data-ad-name");
        var reactTimeAd = localStorage.getItem(name);
        var currentDateTime = new Date();
        if (reactTimeAd === "null" || reactTimeAd < currentDateTime) {
          this.advertisementShow(advertisement);
        }
        $(".confirm-advertisment", advertisement).click(function () {
          var currentDateTimePlusAdDuration = currentDateTime.addDays(adDuration);
          localStorage.setItem(name, currentDateTimePlusAdDuration);
          if (advertisement.hasClass("ad-type-button")) {
            _this2.advertisementHide(advertisement);
          }
        });
        $(".close-advertisment", advertisement).click(function () {
          _this2.advertisementHide(advertisement);
        });
      }
    }
  }, {
    key: "advertisementShow",
    value: function advertisementShow(ad) {
      ad.addClass('show');
    }
  }, {
    key: "advertisementHide",
    value: function advertisementHide(ad) {
      ad.removeClass('show');
    }
  }, {
    key: "setTelPrefixToDefault",
    value: function setTelPrefixToDefault() {
      $("select[name='prefix_number']").change(function () {
        var s = $("select[name='prefix_number'] option:selected").text();
        var x = $("select[name='prefix_number']").parent().find(".placeholder-text").html(s.split(' (')[0]);
      });
    }
  }, {
    key: "getClientIPInfo",
    value: function getClientIPInfo() {
      var result = null;
      $.ajax({
        url: "https://ipinfo.io",
        dataType: "json",
        async: false,
        success: function success(data) {
          result = data;
        }
      });
      return result;
    }
  }, {
    key: "showPrivacyInformation",
    value: function showPrivacyInformation() {
      $(document).on('click', '.showPrivacyInformation', function (e) {
        $('#privacyInformationPopover').modal();
      });
    }
  }, {
    key: "initTestimonialSliderMultiple",
    value: function initTestimonialSliderMultiple() {
      var _this3 = this;
      var multipleTestimonialSlider = new Swiper('.testimonial-slider-multiple', {
        direction: 'horizontal',
        loop: true,
        speed: 500,
        watchActiveIndex: true,
        initialSlide: Math.floor(Math.random() * 5),
        autoplay: false,
        slidesPerView: "auto",
        centeredSlides: true,
        //autoHeight: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
      $(".swiper-button-next").click(function (e) {
        var _this = $(e.currentTarget);
        var slider = _this.parents(".swiper-container");
        _this3.stopVideosInSlider(slider);
      });
      $(".swiper-button-prev").click(function (e) {
        var _this = $(e.currentTarget);
        var slider = _this.parents(".swiper-container");
        _this3.stopVideosInSlider(slider);
      });
      $(".testimonial-slider-multiple .play-icon").click(function (e) {
        var _this = $(e.currentTarget);
        multipleTestimonialSlider.autoplay.stop();
      });
    }
  }, {
    key: "stopVideosInSlider",
    value: function stopVideosInSlider(slider) {
      $(".playVideoTestimonial", slider).each(function (index, videoWrapper) {
        var videoExists = false;
        if ($(".video", videoWrapper).length > 0) {
          videoExists = true;
        }
        if (videoExists === true) {
          var video = $(".video", videoWrapper);
          video.remove();
          $(videoWrapper).removeClass("loading");
          $(videoWrapper).removeClass("hidePlayIcon");
        }
      });
    }
  }, {
    key: "initLazyLoadImage",
    value: function initLazyLoadImage() {
      var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
        // ... more custom settings?
      });
    }
  }, {
    key: "getScrollHeaderDifference",
    value: function getScrollHeaderDifference() {
      return 30; //TODO: Difference between expanded/collapse header height on scroll
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      return this.header.getHeight();
    }
  }, {
    key: "getFooterHeight",
    value: function getFooterHeight() {
      return $(this.footer).outerHeight(true);
    }
  }, {
    key: "initVideoTestimonials",
    value: function initVideoTestimonials() {
      $(document).on('click', '.playVideoTestimonial', function (e) {
        var _this = $(e.currentTarget);
        var src = _this.attr("data-yt");
        var img = _this.find("img");
        _this.addClass("loading");
        $(_this).append($('<iframe>'));
        var videoFrame = _this.find("iframe");
        videoFrame.addClass("video");
        videoFrame.attr("allow", "autoplay");
        videoFrame.attr("allowfullscreen", "allowfullscreen");
        videoFrame.attr("frameBorder", "0");
        videoFrame.attr("src", "https://www.youtube.com/embed/" + src + "?autoplay=1&rel=0&fs=1&wmode=opaque");
        videoFrame.on("load", function (e) {
          var _this = $(e.currentTarget);
          _this.parents(".playVideoTestimonial").addClass("hidePlayIcon");
        });
      });
      this.fullScreenMode = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen; // This will return true or false depending on if it's full screen or not.

      // WORKAROUND FOR SAFARI - Because if section with class arrows contains YT video, video fullscreen show incorect
      var sectionWithArrowClass = [];
      $(document).on('mozfullscreenchange webkitfullscreenchange fullscreenchange', function () {
        this.fullScreenMode = !this.fullScreenMode;
        if (this.fullScreenMode === false) {
          sectionWithArrowClass.forEach(function (item) {
            $(item).addClass("arrow");
          });
          sectionWithArrowClass = [];
        } else {
          $("section").each(function (i, el) {
            if ($(el).hasClass("arrow")) {
              sectionWithArrowClass.push(el);
              $(el).removeClass("arrow");
            }
          });
        }
      });
    }
  }, {
    key: "initSliders",
    value: function initSliders() {
      var slider = new Swiper('.default-slider', {
        direction: 'horizontal',
        loop: true,
        speed: 500,
        autoHeight: true,
        autoplay: false,
        shortSwipes: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
    }
  }, {
    key: "initCoverParallax",
    value: function initCoverParallax() {
      var speedCover;
      var speedInner;
      if (this.platform.iOSDevice() && this.platform.deviceModel()) {
        speedCover = -1;
        speedInner = -1;
      } else {
        speedCover = -4;
        speedInner = -5;
      }
      if ($('.cover-parallax').length) {
        var bgParallax = new Rellax('.cover-parallax', {
          speed: speedCover,
          center: false,
          wrapper: null,
          round: false,
          vertical: true,
          horizontal: false
        });
      }
      if ($('.cover-parallax-inner').length) {
        var contentParallax = new Rellax('.cover-parallax-inner', {
          speed: speedInner,
          center: false,
          wrapper: null,
          round: false,
          vertical: true,
          horizontal: false
        });
      }
    }
  }, {
    key: "initTileParallax",
    value: function initTileParallax() {
      var speedTile = -1.1;
      var speedInner = -1.2;
      if ($('.tile-parallax').length) {
        var bgParallax = new Rellax('.tile-parallax', {
          speed: speedTile,
          center: true,
          wrapper: null,
          round: false,
          vertical: true,
          horizontal: false
        });
      }
      if ($('.tile-parallax-inner').length) {
        var contentParallax = new Rellax('.tile-parallax-inner', {
          speed: speedInner,
          center: true,
          wrapper: null,
          round: false,
          vertical: true,
          horizontal: false
        });
      }
    }
  }, {
    key: "initStickyParallax",
    value: function initStickyParallax() {
      var speedTile = 0;
      var speedInner = -0.8;
      if ($('.sticky-parallax').length) {
        var bgParallax = new Rellax('.sticky-parallax', {
          speed: speedTile,
          center: true,
          wrapper: null,
          round: false,
          vertical: true,
          horizontal: false
        });
      }
      if ($('.sticky-parallax-inner').length) {
        var contentParallax = new Rellax('.sticky-parallax-inner', {
          speed: speedInner,
          center: true,
          wrapper: null,
          round: false,
          vertical: true,
          horizontal: false
        });
      }
    }
  }, {
    key: "initNumberCounters",
    value: function initNumberCounters() {
      $('[data-number-counter="true"]').each(function (index) {
        var counter = new NumberCounter($(this));
      });
    }
  }, {
    key: "initTileHighlightOnScroll",
    value: function initTileHighlightOnScroll() {
      var _this = this;
      if (!this.platform.isDesktop()) {
        $('[data-hightlight="true"]').each(function (index) {
          var tile = new TileHighlightOnScroll($(this), $(this).data('hightlightIsSecond'), $(this).data('highlightFullWidth'));
        });
      }
    }

    /* 
        Delayed tap/click for link/tile highlight on iOS
    */
  }, {
    key: "initHighlightTapLinks",
    value: function initHighlightTapLinks() {
      var _this4 = this;
      $('#content a, .tools-items .item').on('touchstart touchend', function () {
        void 0;
      });
      $('.tools-items .item, .tools-items .item a').click(function (e) {
        e.preventDefault();
        var link = $(e.currentTarget);
        var url;
        if (link.prop('tagName') === 'A') {
          url = link.attr('href');
        } else {
          url = link.data('href');
        }
        if (url) {
          if (_this4.platform.isPhone() || _this4.platform.isTablet()) {
            setTimeout(function () {
              window.location.href = url;
            }, 300);
          } else {
            window.location.href = url;
          }
        }
        return false;
      });
    }
  }, {
    key: "initAnchorScroll",
    value: function initAnchorScroll(offsetCover) {
      var _this5 = this;
      if (window.location.hash) {
        var hash = window.location.hash.substring(1);
        console.log(hash);
        // find the anchored element
        var el = $('[data-anchor="' + hash + '"]').first();
        setTimeout(function () {
          var durationMin = 0.5;
          var durationMax = 1.5;
          var durationFactor = 700;
          var offset = -(_this5.getHeaderHeight() + offsetCover);
          var elementTop = Math.round(el.offset().top + (!isNaN(offset) ? offset : 0));
          var currentPageTop = $(document).scrollTop();
          var distance = elementTop - currentPageTop;
          var duration = distance / durationFactor;

          // set duration bounds
          duration = Math.max(duration, durationMin);
          duration = Math.min(duration, durationMax);
          $('html, body').stop().animate({
            scrollTop: elementTop
          }, duration * 300, 'swing');
        }, 300);
      }
    }
  }, {
    key: "clickToAnchorScroll",
    value: function clickToAnchorScroll() {
      var _this = this;
      $(".link-to-scroll").click(function () {
        console.log('xxx click anchor');
        var button = $(this);
        var anchor = $(button).attr('data-scroll-anchor');
        NavigationUtils.scrollToElement($("[data-anchor='" + anchor + "']"), -145);
      });
    }
  }]);
}();